import script from "./ProfileMetaForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileMetaForm.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileMetaForm.vue?vue&type=style&index=0&id=5c8cd5ae&lang=scss"

const __exports__ = script;

export default __exports__